export default "__VITE_ASSET__1d5ad659__"